<section *ngIf="attachments" class="file-attachments-container">
    <ng-container *ngFor="let file of attachments ; let i = index" class="file-attachment">
      <div *ngIf="!file.deleted" class="file-attachment">
        <a *ngIf="!filePlanId" href="{{server}}/api/file?file={{file.file}}&amp;fileName={{file.fileName}}&amp;auth={{token}}" target="_blank">{{ file.fileName }}</a>
        <a *ngIf="filePlanId" href="{{server}}/api/admin/accessRequestFile?file={{file.file}}&amp;fileName={{file.fileName}}&amp;auth={{token}}&filePlanId={{filePlanId}}" target="_blank">{{ file.fileName }}</a>
        <span *ngIf="!readOnly" class="closing-file" (click)="deleteFile(file.file, file.itemId)">
            <img src="../../../assets/img/close-btn3.svg" alt="">
        </span>
      </div>
    </ng-container>
</section>
